export const leverageSteps = [
  50, 100, 200, 500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000, 6969,
];

export const [defaultLeverageStep] = leverageSteps;
